/** @file Orthographic projection of a world point to screen pixels plus view depth. */
import type { Vec3 } from '../vec3/vec3';
import type { OrthoBasis } from './orthoBasis';

/**
 * `[sx, sy, depth]`: sx = p . right and sy = -(p . up) in pixels (screen y down), relative to the screen
 * position of the world origin; depth = -(p . back) in units, growing away from the camera.
 */
export function projectOrtho(p: Vec3, basis: OrthoBasis, pixelsPerUnit: number): Vec3 {
  const { right, up, back } = basis;
  return [
    (p[0] * right[0] + p[1] * right[1] + p[2] * right[2]) * pixelsPerUnit,
    -(p[0] * up[0] + p[1] * up[1] + p[2] * up[2]) * pixelsPerUnit,
    -(p[0] * back[0] + p[1] * back[1] + p[2] * back[2]),
  ];
}
